// ============================
// 共通タイミング定数
// マジックナンバーをここに集約。SCSS 側の値と関連するものは「SCSS の XXX と一致」コメントを併記。
// ============================
var TIMING = {
  // Main Visual 演出
  introStaggerMs:      300,  // 要素ごとのスタッガー
  fontFallbackMs:      3500, // Typekit scriptTimeout=3000ms + 余裕（フォント未解決でも強制発火）

  // IntersectionObserver fade-in
  observeStaggerMs:    200,  // 複数要素が同時にビューポート侵入したときのスタッガー
  observeThreshold:    0.15,

  // カルーセル
  carouselJumpDelayMs: 360,  // CSS transition 0.35s + 10ms バッファ（実カードへの静かなジャンプ）
};

// ============================
// Main Visual - 初回ロード演出（Web フォント読み込み完了後に発火）
// ・SCSS の .main-visual.is-playing 配下で animation 発火
// ・Adobe Typekit が <html> に付与する wf-active（成功） / wf-inactive（失敗）を待つ
//   → これが「フォントの @font-face ロード＆描画適用が完了した最も確実なシグナル」
// ・document.fonts.ready は Typekit の @font-face 注入前に即 resolve することがあるため使用しない
// ・セーフティ：TIMING.fontFallbackMs（Typekit の scriptTimeout=3000ms に余裕を足した上限）
// ・1ページロードにつき1回のみ実行
// ============================
(function () {
  var mv = document.querySelector('.main-visual');
  if (!mv) return;

  // Main Visual 内のフェードイン要素は IntersectionObserver ではなく
  // .is-playing 付与時にスタッガーで個別に発火させる
  var mvFadeTargets = Array.from(mv.querySelectorAll('.galaxy-js-fade-in'));

  var fired = false;
  function startMV() {
    if (fired) return;
    fired = true;
    mv.classList.add('is-playing');
    // .is-playing 付与と同時にスタッガーで .galaxy-is-visible 付与
    mvFadeTargets.forEach(function (el, i) {
      setTimeout(function () {
        el.classList.add('galaxy-is-visible');
      }, i * TIMING.introStaggerMs);
    });
  }

  var htmlEl = document.documentElement;
  function isFontResolved() {
    return htmlEl.classList.contains('wf-active') ||
           htmlEl.classList.contains('wf-inactive');
  }

  if (isFontResolved()) {
    startMV();
  } else if ('MutationObserver' in window) {
    var wfObserver = new MutationObserver(function () {
      if (isFontResolved()) {
        wfObserver.disconnect();
        startMV();
      }
    });
    wfObserver.observe(htmlEl, { attributes: true, attributeFilter: ['class'] });
  }

  setTimeout(startMV, TIMING.fontFallbackMs);
})();

// フェードイン: 要素がビューポートに入ったら .galaxy-is-visible を付与
// Main Visual 内の要素は上のイントロ処理で個別に扱うため除外
const fadeTargets = Array.from(document.querySelectorAll('.galaxy-js-fade-in'))
  .filter((el) => !el.closest('.main-visual'));

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        // 複数要素が同時に入ったとき少しずらして表示
        setTimeout(() => {
          entry.target.classList.add('galaxy-is-visible');
        }, i * TIMING.observeStaggerMs);
        observer.unobserve(entry.target);
      }
    });
  },
  { threshold: TIMING.observeThreshold }
);

fadeTargets.forEach((el) => observer.observe(el));

// ============================
// 5 FLAVORS カルーセル（無限ループ）
// ============================
(function () {
  var wrap      = document.querySelector('.flavors__carousel-wrap');
  var track     = document.querySelector('.flavors__track');
  var origCards = Array.from(document.querySelectorAll('.flavors__card'));
  var dots      = Array.from(document.querySelectorAll('.flavors__dot'));
  var btnPrev   = document.querySelector('.flavors__btn-prev');
  var btnNext   = document.querySelector('.flavors__btn-next');

  if (!wrap || !track || origCards.length === 0) return;

  var CARD_WIDTH = 300;
  var GAP        = 18;
  var TOTAL      = origCards.length; // 5

  // 両端に TOTAL 枚ずつクローンを追加（PC の広いビューポートでも途切れない）
  // 前クローン: orig[0]〜orig[4] の順で insertBefore → 位置0がorig[0]複製、位置4がorig[4]複製
  for (var i = 0; i < TOTAL; i++) {
    var pre = origCards[i].cloneNode(true);
    pre.setAttribute('aria-hidden', 'true');
    track.insertBefore(pre, origCards[0]);
  }
  // 後クローン: orig[0]〜orig[4] の順で appendChild
  for (var j = 0; j < TOTAL; j++) {
    var post = origCards[j].cloneNode(true);
    post.setAttribute('aria-hidden', 'true');
    track.appendChild(post);
  }

  // 全カード: [clone×5] + [orig×5] + [clone×5] = 15枚
  var allCards = Array.from(track.querySelectorAll('.flavors__card'));

  // 実カードは index TOTAL〜TOTAL*2-1（5〜9）
  var current   = TOTAL;
  var isJumping = false;

  function setTransform(index, animated) {
    var wrapWidth  = wrap.offsetWidth;
    var sideOffset = (wrapWidth - CARD_WIDTH) / 2;
    var offset     = index * (CARD_WIDTH + GAP) - sideOffset;
    track.style.transition = animated ? 'transform 0.35s ease' : 'none';
    track.style.transform  = 'translateX(' + (-offset) + 'px)';
  }

  function updateDots() {
    var dotIndex = current % TOTAL;
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === dotIndex);
    });
  }

  function updateActiveCard() {
    allCards.forEach(function (card, i) {
      card.classList.toggle('is-active', i === current);
    });
  }

  function update(animated) {
    setTransform(current, animated !== false);
    updateDots();
    updateActiveCard();
  }

  function go(index) {
    if (isJumping) return;
    current = index;
    update(true);

    // クローン領域に入ったらアニメーション完了後に実カードへ静かにジャンプ
    if (current < TOTAL) {
      isJumping = true;
      setTimeout(function () {
        // カードのトランジションを一時無効化してから位置を更新（translateY のちらつき防止）
        allCards.forEach(function (c) { c.classList.add('is-no-transition'); });
        current = current + TOTAL;
        update(false);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            allCards.forEach(function (c) { c.classList.remove('is-no-transition'); });
            isJumping = false;
          });
        });
      }, TIMING.carouselJumpDelayMs);
    } else if (current >= TOTAL * 2) {
      isJumping = true;
      setTimeout(function () {
        allCards.forEach(function (c) { c.classList.add('is-no-transition'); });
        current = current - TOTAL;
        update(false);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            allCards.forEach(function (c) { c.classList.remove('is-no-transition'); });
            isJumping = false;
          });
        });
      }, TIMING.carouselJumpDelayMs);
    }
  }

  btnPrev.addEventListener('click', function () { go(current - 1); });
  btnNext.addEventListener('click', function () { go(current + 1); });

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { go(i + TOTAL); });
  });

  // クリック挙動: 中央（current）の <a> はリンク遷移を許可、それ以外はカルーセル送りに使う
  // クローン含む全カードにリスナーを付けて、左右の peek セルからも送れるようにする
  allCards.forEach(function (card, i) {
    card.addEventListener('click', function (e) {
      if (i === current) return; // 中央カードはリンクをそのまま辿らせる
      e.preventDefault();
      go(i);
    });
  });

  // タッチスワイプ
  // スワイプ判定時は touchend 後の click をキャンセル（リンク誤遷移防止）
  var touchStartX = 0;
  var touchStartTime = 0;
  var suppressNextClick = false;
  track.addEventListener('touchstart', function (e) {
    touchStartX    = e.touches[0].clientX;
    touchStartTime = Date.now();
  }, { passive: true });
  track.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dt = Date.now() - touchStartTime;
    if (Math.abs(dx) > 40 && dt < 400) {
      suppressNextClick = true;
      go(dx > 0 ? current - 1 : current + 1);
    }
  });
  // capture フェーズでスワイプ直後の click を握り潰す
  track.addEventListener('click', function (e) {
    if (suppressNextClick) {
      e.preventDefault();
      e.stopPropagation();
      suppressNextClick = false;
    }
  }, true);

  window.addEventListener('resize', function () { update(false); });

  // 初期表示（アニメーションなし）
  update(false);
})();

// ============================
// 7-2 CUSTOMIZE カルーセル（SPのみ・無限ループ）
// PC では3列フィックス表示・JSはトラックを変形しない
// ============================
(function () {
  var wrap     = document.querySelector('.howto__customize-wrap');
  if (!wrap) return;

  var track    = wrap.querySelector('.howto__customize-track');
  var origCards = Array.from(wrap.querySelectorAll('.howto__step--customize'));
  var dots     = Array.from(wrap.querySelectorAll('.howto__customize-dot'));
  var btnPrev  = wrap.querySelector('.howto__customize-prev');
  var btnNext  = wrap.querySelector('.howto__customize-next');

  if (!track || origCards.length === 0) return;

  // iOS Safari 対策: window レベルに passive な touchstart リスナーを置くと
  // 子要素の touch イベントが安定して発火する（これがないと一部状況で
  // .howto__customize-track 上の touchstart が iOS Safari に届かない）
  // 中身は意図的に空のままにしておく（リスナーが存在することだけが重要）
  window.addEventListener('touchstart', function () {}, { passive: true, capture: true });

  var TOTAL = origCards.length; // 3
  // カードは隙間なし＋ margin-left:-1px で境界線を共有するため、送り幅 = カード幅 - 1

  // 両端にクローンを追加（SPのみ意味があるが、PCではCSSで display:none）
  for (var i = 0; i < TOTAL; i++) {
    var pre = origCards[i].cloneNode(true);
    pre.classList.add('howto__step--clone');
    pre.setAttribute('aria-hidden', 'true');
    track.insertBefore(pre, origCards[0]);
  }
  for (var j = 0; j < TOTAL; j++) {
    var post = origCards[j].cloneNode(true);
    post.classList.add('howto__step--clone');
    post.setAttribute('aria-hidden', 'true');
    track.appendChild(post);
  }

  // 全カード（クローン込み）: [clone×3] + [orig×3] + [clone×3] = 9
  var allCards = Array.from(track.querySelectorAll('.howto__step--customize'));

  // 実カードは index TOTAL〜TOTAL*2-1（3〜5）
  var current   = TOTAL;
  var isJumping = false;

  function isSP() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function setTransform(index, animated) {
    if (!isSP()) {
      // PC: インラインの transform/transition をクリアして3列フィックスに戻す
      track.style.transform  = '';
      track.style.transition = '';
      return;
    }
    var wrapWidth  = wrap.offsetWidth;
    var cardWidth  = allCards[TOTAL].offsetWidth;     // 実カードの幅 = calc(100vw - 60px)
    var sideOffset = (wrapWidth - cardWidth) / 2;     // peek 用の左右オフセット
    var step       = cardWidth - 1;                    // margin-left:-1px ぶん詰める
    var offset     = index * step - sideOffset;
    track.style.transition = animated ? 'transform 0.35s ease' : 'none';
    track.style.transform  = 'translateX(' + (-offset) + 'px)';
  }

  function updateDots() {
    var dotIndex = ((current - TOTAL) % TOTAL + TOTAL) % TOTAL;
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === dotIndex);
    });
  }

  function update(animated) {
    setTransform(current, animated !== false);
    updateDots();
  }

  function go(index) {
    if (isJumping) return;
    if (!isSP()) return;
    current = index;
    update(true);

    // クローン領域に入ったらアニメーション完了後に実カードへ静かにジャンプ
    if (current < TOTAL) {
      isJumping = true;
      setTimeout(function () {
        current = current + TOTAL;
        update(false);
        isJumping = false;
      }, TIMING.carouselJumpDelayMs);
    } else if (current >= TOTAL * 2) {
      isJumping = true;
      setTimeout(function () {
        current = current - TOTAL;
        update(false);
        isJumping = false;
      }, TIMING.carouselJumpDelayMs);
    }
  }

  if (btnPrev) btnPrev.addEventListener('click', function () { go(current - 1); });
  if (btnNext) btnNext.addEventListener('click', function () { go(current + 1); });

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { go(i + TOTAL); });
  });

  // タッチスワイプ（ドラッグ追従型）
  // 指の動きにカードがリアルタイムで追従するので、ユーザー操作として明示的に処理される
  // → iOS Safari/Chrome のスクロール優先・back-swipe 横取り対策・反応性向上
  var touchStartX = 0;
  var touchStartY = 0;
  var baseTranslate = 0;     // touchstart 時点での translateX 値
  var axisLocked  = false;
  var isHorizontal = false;
  var isDragging  = false;

  // 現在の current インデックスに対応する translateX を計算
  function getBaseTranslate() {
    var wrapWidth  = wrap.offsetWidth;
    var cardWidth  = allCards[TOTAL].offsetWidth;
    var sideOffset = (wrapWidth - cardWidth) / 2;
    var step       = cardWidth - 1;
    return -(current * step - sideOffset);
  }

  track.addEventListener('touchstart', function (e) {
    if (!isSP() || isJumping) return;
    touchStartX  = e.touches[0].clientX;
    touchStartY  = e.touches[0].clientY;
    baseTranslate = getBaseTranslate();
    axisLocked   = false;
    isHorizontal = false;
    isDragging   = true;
    // 追従中はトランジションを切る
    track.style.transition = 'none';
  }, { passive: true });

  track.addEventListener('touchmove', function (e) {
    if (!isDragging || !isSP()) return;
    var dx = e.touches[0].clientX - touchStartX;
    var dy = e.touches[0].clientY - touchStartY;

    // 軸ロック（4pxで早期判定）
    if (!axisLocked) {
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) {
        axisLocked   = true;
        isHorizontal = Math.abs(dx) >= Math.abs(dy);
      } else {
        return;
      }
    }
    if (!isHorizontal) return; // 縦方向はページスクロールに任せる

    // 横方向: ページスクロールを抑止して指に追従
    if (e.cancelable) e.preventDefault();
    track.style.transform = 'translateX(' + (baseTranslate + dx) + 'px)';
  }, { passive: false });

  function finishDrag(dx) {
    isDragging = false;
    if (!axisLocked || !isHorizontal) return;
    // 送り判定: カード幅の15% を超えたらコミット、それ以下はスナップバック
    var cardWidth = allCards[TOTAL].offsetWidth;
    var threshold = Math.max(30, cardWidth * 0.15);
    if (Math.abs(dx) > threshold) {
      go(dx > 0 ? current - 1 : current + 1);
    } else {
      // 元の位置にスナップバック
      setTransform(current, true);
    }
  }

  track.addEventListener('touchend', function (e) {
    if (!isSP()) return;
    var dx = isDragging ? (e.changedTouches[0].clientX - touchStartX) : 0;
    finishDrag(dx);
  });

  track.addEventListener('touchcancel', function () {
    if (!isSP()) return;
    // キャンセル時は元の位置に戻す
    isDragging = false;
    axisLocked = false;
    isHorizontal = false;
    setTransform(current, true);
  });

  window.addEventListener('resize', function () { update(false); });

  // 初期表示（アニメーションなし）
  update(false);
})();

// ============================
// カスタムスクロールバー（SPのみ動作）
// iOS Safari が ::-webkit-scrollbar を無視する仕様への対策として、
// JS で scrollLeft / scrollWidth を監視し DOM ベースのつまみを同期更新する
// ============================
(function () {
  var bars = Array.from(document.querySelectorAll('.galaxy-js-custom-scrollbar'));
  if (bars.length === 0) return;

  function isSP() { return window.matchMedia('(max-width: 767px)').matches; }

  bars.forEach(function (bar) {
    var selector = bar.getAttribute('data-scroll-target');
    if (!selector) return;
    var target = document.querySelector(selector);
    var thumb  = bar.querySelector('.galaxy-custom-scrollbar__thumb');
    if (!target || !thumb) return;

    function update() {
      if (!isSP()) return;
      var scrollWidth = target.scrollWidth;
      var clientWidth = target.clientWidth;
      // スクロール不要ならバー自体を隠す
      if (scrollWidth <= clientWidth + 1) {
        bar.style.display = 'none';
        return;
      }
      bar.style.display = '';
      var trackWidth = bar.clientWidth;
      // つまみ幅: 可視幅 / コンテンツ全幅 の比率（最小16px）
      var thumbWidth = Math.max(16, Math.round(trackWidth * (clientWidth / scrollWidth)));
      // スクロール位置に応じてつまみを移動
      var maxScroll = scrollWidth - clientWidth;
      var maxThumbX = trackWidth - thumbWidth;
      var x         = maxScroll > 0 ? (target.scrollLeft / maxScroll) * maxThumbX : 0;
      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + x + 'px)';
    }

    target.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    // 画像ロード後にスクロール幅が変わるケースに備えて load 時も再計算
    window.addEventListener('load', update);
    // 初期描画
    update();
  });
})();

// ============================
// MOVIE - カスタム再生ボタン制御 + 初期音量設定
// ・初期音量は 0.5（中間）に設定（ユーザーが controls で変更したら以降はその値を維持）
// ・.movie__play-btn クリックで video.play()
// ・video の play / pause / ended イベントで .is-hidden をトグル
//   → 一時停止・終了時にもボタンを再表示する仕様
// ============================
(function () {
  var video   = document.querySelector('.movie__video');
  var playBtn = document.querySelector('.movie__play-btn');
  if (!video || !playBtn) return;

  // 初期音量を中間に（メタデータロード前でも安全に設定可能）
  video.volume = 0.5;

  // クリックで再生開始（play イベントでボタン非表示が走る）
  playBtn.addEventListener('click', function () {
    // .play() は Promise を返す。autoplay ポリシーや競合で reject される可能性に備えて catch
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () { /* 再生失敗時は何もしない（ボタンはそのまま残る） */ });
    }
  });

  // 再生開始 → ボタン非表示
  video.addEventListener('play', function () {
    playBtn.classList.add('is-hidden');
  });

  // 一時停止 → ボタン再表示（トグル仕様）
  video.addEventListener('pause', function () {
    playBtn.classList.remove('is-hidden');
  });

  // 終了 → ボタン再表示
  video.addEventListener('ended', function () {
    playBtn.classList.remove('is-hidden');
  });
})();
